import { render, staticRenderFns } from "./InputTextMailFromWhiteListDialog.vue?vue&type=template&id=a87b2b32"
import script from "./InputTextMailFromWhiteListDialog.vue?vue&type=script&lang=js"
export * from "./InputTextMailFromWhiteListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports